/**
 * @Author:      ge.yuankai
 * @DateTime:    2018-03-19
 * @Description: 渠道审核不通过
 */
"use strict";
angular.module("channelAuditFailModule", []).
controller("channelAuditFailCtrl", ["$scope", "$modalInstance","userId","channelId","httpService","modalDialog", function($scope,$modalInstance,userId,channelId,httpService,modalDialog) {
    initStatus();
	initData();
    function initStatus() {
        $scope.status = {
        	
        };
        $scope.data = {
        	userId  : userId,
        	channelId  : channelId,
        	reason:""
        }
    }
    function initData(){
    }
    $scope.confirm = function() {
    	$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcuser/userChannelAuditFail.do", $scope.data, "post").then(function(data) {
			$modalInstance.close(data);
        });
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}]);